import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'pl' ? 'en' : 'pl';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      className="language-switcher"
      onClick={toggleLanguage}
      aria-label={t('language.switchTo')}
    >
      <span className={`flag ${i18n.language === 'pl' ? 'pl' : 'en'}`}>
        {i18n.language === 'pl' ? '🇵🇱' : '🇺🇸'}
      </span>
      <span className="lang-text">
        {i18n.language === 'pl' ? 'EN' : 'PL'}
      </span>
    </button>
  );
};

export default LanguageSwitcher;